import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import {
  Box,
  Drawer,
  Grid,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import approvalActions from "./actions";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const useStyles = makeStyles((theme) => ({
  success: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.success.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.success.main,
      color: "#FFF",
    },
  },
  error: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.error.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      color: "#FFF",
    },
  },
}));

const TableActions = () => {
  const classes = useStyles();
  const { updatePendingUser } = approvalActions();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const approve = () => {
    updatePendingUser("approve");
  };
  const deny = () => {
    updatePendingUser("deny");
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  const getButtons = () => (
    <Grid
      container
      justify={matches ? "flex-start" : "center"}
      alignContent="center"
      direction="row"
    >
      <Button
        size={matches ? "small" : "large"}
        className={classes.success}
        onClick={() => setTimeout(() => approve(), 0)}
      >
        Approve
      </Button>
      <Button
        size={matches ? "small" : "large"}
        className={classes.error}
        onClick={() => setTimeout(() => deny(), 0)}
      >
        Deny
      </Button>
    </Grid>
  );
  return matches ? (
    getButtons()
  ) : (
    <>
      <Button
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon />
      </Button>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <Box m={2}>{getButtons()}</Box>
      </Drawer>
    </>
  );
};

export default TableActions;
